import { makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  () =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: 0,
        marginBottom: 0,
      },
      content: {
        fontFamily: '"Nunito"',
        fontWeight: 300,
        fontSize: '16px',
        textAlign: 'justify',
        letterSpacing: '0.44px',
        whiteSpace: 'pre-line',
      },
      textItens: {
        marginBottom: '10px',
      },
      formControl: {
        width: '100%',
        color: '#323C32',
      },
      confirmButtom: {
        marginTop: '50px',
        textAlign: 'right',
      },
    }),
  {
    name: 'CadastrarTextoAssociadoModal',
  }
);
